import axios from "axios";
import { endpointApi } from "../../utils";
import { logout } from "./auth.action";
import { ARTICLE_LIST_FAIL, ARTICLE_LIST_REQUEST, ARTICLE_LIST_SUCCESS } from "../constats/article.constant";

export const getArticles = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: ARTICLE_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }articles${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: ARTICLE_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: ARTICLE_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: ARTICLE_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}